module.exports = __webpack_public_path__ + "static/six_month_ledger-fe586f3ab3fe5d2ced2f87c8e004d6d9.png";